/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { DateRangeFilter, } from './DateRangeFilter/DateRangeFilter';
import { NumberRangeFilter, } from './NumberRangeFilter/NumberRangeFilter';
import { TextFilter } from './TextFilter/TextFilter';
export const tableFilters = {
    /**
     * Basic filter with a single input field.
     * @param translatedLabels Translated filter labels.
     */
    TextFilter: (translatedLabels) => (props) => React.createElement(TextFilter, { ...props, translatedLabels: translatedLabels }),
    /**
     * Date range filter.
     *
     * By default it handles user input in `en-us` date format. If you want to use other format
     * please provide `formatDate`, `parseInput` and `placeholder`.
     *
     * It only works with `Date` type object properties.
     * If your data is different type e.g. `string`, you can use `accessor` property in column description:
     * `accessor: (rowData) => new Date(rowData.date)`.
     */
    DateRangeFilter: (options) => (props) => React.createElement(DateRangeFilter, { ...props, ...options }),
    /**
     * Number range filter.
     *
     * It only works with `number` type object properties.
     * If your data is different type e.g. `string`, you can use `accessor` property in column description:
     * `accessor: (rowData) => Number(rowData.numberProp)`.
     * @param translatedLabels Translated filter labels.
     */
    NumberRangeFilter: (translatedLabels) => (props) => React.createElement(NumberRangeFilter, { ...props, translatedLabels: translatedLabels }),
};
